<template>
  <div class="main">
    <search-head :showMax="true" />
    <div class="content clearfix" style="padding-top:16px">
      <div class="contentLeft">

        <!-- <div class="banner">
          <el-carousel trigger="click" ref="carousel" height="168px" :interval="5000" :autoplay="true" >
            <el-carousel-item @click.native="$router.push({path:'/zxk/junbros/advancedSearch'})">
              <img src="@/assets/banner/banner2.png" style="width: 100%;height: 168px;" alt="">
            </el-carousel-item>
            <el-carousel-item @click.native="imgDialog = true">
              <img src="@/assets/banner/banner1.png" style="width: 100%;height: 168px;" alt="" >
            </el-carousel-item>
          </el-carousel>
        </div> -->

        <div class="banner">
          <div class="cover" @click="clickMarbItem('6', '/zxk/junbros/advancedSearch')">
            <img style="width:100%" src="@/assets/newicons/ic01.png" alt="">
          </div>
        </div>

        <div class="div-search">
          <div class="search-content">

            <div style="padding: 0px 0px;" class="div-scrollbar">

              <el-scrollbar style="height:100%;">

                <div style="padding-left:24px;padding-right:24px">

                  <div class="search-title">区域查询</div>
                  <span class="span-tag" v-for="(item, i) in fastLabel" :key="i" @click="chooseCity(item,i)">{{item.label}}</span>
                  <ul style="margin-top:17px">
                    <li v-for="(area, i) in areaCode" :key="i">
                      <b @click="chooseCity(area,i)" style="font-weight: blod;color: #333333;">{{area.label}}</b>
                      <span>
                        <em v-for="(city,index) in area.childOption" :key="index" @click="chooseCity(area,i,city,index)">{{city.label}}</em>
                      </span>
                    </li>
                  </ul>
                </div>
              </el-scrollbar>

            </div>

          </div>
          <div class="search-content ml-20">

            <div style="padding: 0px 0px;" class="div-scrollbar">

              <el-scrollbar style="height:100%">
                <div style="padding-left:24px;padding-right:24px">
                  <div class="search-title">行业查询</div>
                  <ul>
                    <li v-for="(item,i) in industryInfo" :key="i">
                      <b @click="chooseIndustry(item,i)" style="width:120px;font-weight: blod;color: #333333;">{{item.industry}}</b>
                      <span style="width: calc(100% - 140px);">
                        <em v-for="(children,index) in item.children" :key="index" @click="chooseIndustry(item,i,children,index)">{{children.industry}}</em>
                      </span>
                    </li>
                  </ul>
                </div>
              </el-scrollbar>

            </div>

          </div>
        </div>
        <div class="leftList">
          <div class="title">
            <!-- <h4 :class="tabsType===1? 'is-tabs' : ''" @click="clickTabsType(1)">推荐企业</h4> -->
            <h4 :class="tabsType===2? 'is-tabs' : ''" @click="clickTabsType(2)">最新企业</h4>
            <!-- <div v-if="tabsType===1" @click="recommendList" style="font-size:13px"><img src="@/assets/newicons/shauxin.png">换一换</div> -->
            <div v-if="tabsType===2" @click="newCompany(false)" style="font-size:13px"><img src="@/assets/newicons/shauxin.png">换一换</div>
          </div>

          <!-- <el-scrollbar style="height: 200px">  -->
          <div class="detail" v-loading='waiting' style="min-width:100%;margin-left:-11px;margin-right:-11px;display: inline-block;grid-template-columns: none;overflow: initial;max-height: initial;">
            <div class="new-item" v-for="companyCard in companyCards" :key="companyCard.id">
              <company-card1 :companyType="1" class="companyCard" style="width: 100%;height: 167px !important;margin-top:22px" :baseData="companyCard" :xiaoT="true" @drawer-handle="showDrawer"
                @changeNews-handle="getNews" @change-recommendList="recommendList" />
            </div>

          </div>
          <!-- </el-scrollbar> -->

        </div>
        <div class="leftList" v-if="hideBind">
          <div class="title">
            <h4 class="is-tabs">企业招标</h4>
            <div @click="clickMarbItem('4', '/zxk/search/biddingInquiry')" style="font-size:13px;color:rgba(80, 136, 255, 1)">更多</div>
          </div>
          <div style="padding:16px 0px 0px 0">

            <!-- <el-scrollbar style="height:100%"> -->

            <div class="detail" style="display: block;grid-template-columns: none;overflow: initial;max-height: initial;">

              <div class="cardWrap" v-for="(item,i) in tenderList" :key="i" style="height: 132px;float: none;padding:24px 32px;box-shadow:none">
                <div class="nameWrap mb-10" style="height: 22px;">
                  <span style="font-size:16px;line-height: 22px;color: #333333;font-weight: bold;" class="name textOverflow" :title="item.title">{{item.title}}</span>
                </div>
                <div class="tags mb-10" style="display: inline-block;">
                  <span class="fl colore6a23c sty001" :style="getStyle(item.noticeLevel)">{{item.noticeLevel}}</span>
                </div>
                <!-- <div style="height: 15px;clear:both;"></div> -->
                <dl class="text">
                  <dd class="mr-10" style="max-width: 100%;width: 100%;">
                    <div class="sty004">

                      <div class="textOverflow" style="margin-right:32px">
                        <span class="sty002">相关公司：</span>
                        <span class="textOverflow sty003" :title="item.companyName" v-html="item.companyName"></span>
                      </div>

                      <div class="textOverflow">
                        <span class="sty002">发布时间：</span>
                        <span class="sty003">{{item.dateCol}}</span>
                      </div>

                    </div>

                  </dd>
                </dl>
                <!-- <div class="address textOverflow">
                    <span>企业地址：</span><span ></span>
                  </div> -->
              </div>

            </div>

            <!-- </el-scrollbar> -->

          </div>
        </div>

      </div>
    </div>
    <el-dialog top="5vh" :visible.sync="imgDialog" width="320px" class="imgDialog">
      <img src="@/assets/banner/banner1-dialog.png" style="width: 100%;" alt="">
    </el-dialog>
    <!-- 大转盘抽奖 -->
    <el-dialog class="luckDialog" top="25vh" :visible.sync="LuckyWheelShow" width="480px" :show-close="showClose" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <LuckyWheel ref="LuckyWheel" width="450px" height="450px" :blocks="blocks" :prizes="prizes" :buttons="buttons" @start="startCallBack" @end="endCallBack" />
    </el-dialog>

    <!-- 抽奖2 -->
    <LucklyAnimate v-if="lucklyAnimateShow" @hideMe='hideMe' />

    <robot />
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
// import { areaCode } from '@/base/areaCode'
import { mapState } from 'vuex'
import closeImg from '@/assets/caclose.png'
import openImg from '@/assets/caopen.png'
import LucklyAnimate from '@/components/lucklyAnimate'
import { LuckyWheel, LuckyGrid } from 'vue-luck-draw'
import emptyBox from '@/assets/emptyBox.svg'
import companyCard1 from '../components/companyCard1'
import SearchHead from '../components/searchHead'
import robot from '../components/robot'
import { recommendList, getNews, contactList, opportunityExists, ad1, ad2, newCompany, queryTenderList } from '../api/newClueApi'
import { searchByCondition } from '../api/index'
import RightFloat from '@/components/rightFloatBtn'
export default {
  name: 'Index',
  components: {
    companyCard1,
    SearchHead,
    robot,
    LuckyWheel,
    LucklyAnimate,
    RightFloat
  },
  data() {
    return {
      fastLabel: [
        { label: '北京市', value: '11' },
        { label: '上海市', value: '31' },
        { label: '天津市', value: '12' },
        { label: '重庆市', value: '50' },
        { label: '广东省', value: '44' }
      ],
      // areaCode,
      hideBind: false, // 隐藏招标
      imgDialog: false,
      tabsType: 2, // 1推荐企业 2最新企业
      companyCards: [],
      numberData: [],
      news: [],
      waiting: false,
      loading: false,
      emptyBox,
      companyStatus: { companyName: '', tag: '' },
      searchNewsName: '',
      // ip: 'http://pv.sohu.com/cityjson?ie=utf-8'
      rollList: [],
      rollListTotal: 0,
      rollWaiting: false,
      rollTop: 0,
      rollTimmer: null,
      rollTimmer2: null,
      LuckyWheelShow: false,
      lucklyAnimateShow: false,
      showClose: true,
      closeImg,
      openImg,
      boxList: [
        true,
        true,
        true
      ],
      blocks: [
        { padding: '10px', background: '#d64737' },
        { padding: '0', background: '#fff' }
        // {
        //   padding: '20px',
        //   imgs: [{
        //     src: require('@/assets/zhuanpan.png'),
        //     width: '100%',
        //     rotate: true
        //   }]
        // }
      ],
      prizes: [
        {
          fonts: [{ text: '谢谢参与', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao2.png'), top: 50 }],
          background: '#f8d384'
        },
        {
          fonts: [{ text: '80条', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao.png'), top: 50 }],
          background: '#fff'
        },
        {
          fonts: [{ text: '谢谢参与', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao2.png'), top: 50 }],
          background: '#f8d384'
        },
        {
          fonts: [{ text: '5条', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao.png'), top: 50 }],
          background: '#fff'
        },
        {
          fonts: [{ text: '谢谢参与', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao2.png'), top: 50 }],
          background: '#f8d384'
        },
        {
          type: 1,
          fonts: [{ text: '100条', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao.png'), top: 50 }],
          background: '#fff'
        },
        {
          fonts: [{ text: '谢谢参与', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao2.png'), top: 50 }],
          background: '#f8d384'
        },
        {
          type: 2,
          fonts: [{ text: '200条', fontSize: '12px', top: 20, lengthLimit: '80%' }],
          imgs: [{ src: require('@/assets/hongbao.png'), top: 50 }],
          background: '#fff'
        }
      ],
      buttons: [
        {
          imgs: [{ src: require('@/assets/zhuanpanbtn.png'), width: '180px', top: -110 }]
        },
        {
          fonts: [{ text: '开始\n抽奖', top: -18, fontSize: '16px', fontColor: '#fff' }],
          radius: '20%',
          background: '#dd216c',
          pointer: false
        }
      ],
      recommendListTimer: null,
      tenderList: []
    }
  },
  computed: {
    ...mapState({
      industryInfo: state => state.asyncRoute.industryInfo,
      selectArea: state => state.asyncRoute.selectArea,
    }),
    areaCode() {
      return this.selectArea.filter(e => !this.fastLabel.some(f => f.value == e.value))
    }
  },
  created() {
    this.newCompany()
    this.getNews()
    // this.queryTenderList()
  },
  mounted() {
    // this.setPageWrapPadding()
    // console.log(this.$refs.carousel)
  },
  beforeDestroy() {
    this.getPageWrapPadding()
    clearTimeout(this.rollTimmer)
    clearTimeout(this.rollTimmer2)
  },
  filters: {
    getTime(val) {
      const nowTime = Date.parse(new Date()) // 当前时间戳
      const year = (nowTime - val) / (12 * 30 * 24 * 60 * 60 * 1000)
      if (year > 1) return Math.floor(year) + '年前'
      const month = (nowTime - val) / (30 * 24 * 60 * 60 * 1000)
      if (month > 1) return Math.floor(month) + '月前'
      const day = (nowTime - val) / (24 * 60 * 60 * 1000)
      if (day > 1) return Math.floor(day) + '天前'
      const hour = (nowTime - val) / (60 * 60 * 1000)
      if (hour > 1) return Math.floor(hour) + '小时前'
      const min = (nowTime - val) / (60 * 1000)
      if (min > 1) return Math.floor(min) + '分钟前'
    }
  },
  methods: {
    clickMarbItem(type, path) {
      if (window.__sendIframeLinkMessage({ type })) return
      this.$router.push(path)
    },
    getStyle(str) {
      var ret = {}
      if (str.indexOf('中标公告') > -1) {
        ret.color = 'rgba(48, 191, 120, 1)'
        ret.background = 'rgba(48, 191, 120, 0.15)'
      } else if (str.indexOf('招标公告') > -1) {
        ret.color = 'rgba(80, 136, 255, 1)'
        ret.background = 'rgba(80, 136, 255, 0.15)'
      } else if (str.indexOf('变更公告') > -1) {
        ret.color = 'rgba(255, 160, 0, 1)'
        ret.background = 'rgba(255, 160, 0, 0.15)'
      }
      return ret
    },
    queryTenderList() {
      queryTenderList({ pageNum: 1, pageSize: 9 }).then(res => {
        this.tenderList = res.data.content
      })
    },
    clickTabsType(val) {
      this.tabsType = val
      if (this.tabsType === 1) {
        this.recommendList()
      } else {
        this.newCompany()
      }
    },
    newCompany(isDefault = true) {
      const params = {
        pageNum: typeof isDefault == 'boolean' && !isDefault ? Math.ceil(Math.random() * 10) : 1,
        pageSize: 20,
        estiblishTime: ["12个月以内"],
        sortType: 2,
      }
      this.waiting = true
      searchByCondition(params).then(res => {
        const zz = /[\u4e00-\u9fa5]/g
        this.companyCards = res.data.items
        // 统一数据格式
        this.companyCards.forEach(e => {
          if (!e.hasOwnProperty('unlock')) {
            this.$set(e, 'unlock', false)
          }
          if (!e.hasOwnProperty('star')) {
            this.$set(e, 'star', false)
          }
        })
        this.waiting = false
      })
    },
    removeHtml(str) {
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    chooseCity(area, i, city, index) {
      var query = {
        city: true,
        text: area.label,
        areaCodeId: area.value,
        index: i
      }
      if (city && city.label) {
        query.text1 = city.label
        query.areaCodeId1 = city.value
        query.index1 = index
      }
      if (window.__sendIframeLinkMessage({ type: '2-1', query })) return
      this.$router.push({
        path: '/zxk/search/clueList',
        query: query
      })
    },
    chooseIndustry(item, i, children, index) {
      var query = {
        industry: true,
        text: item.industry,
        categoryId: item.industryCode,
        index: i
      }
      if (children && children.industry) {
        query.text1 = children.industry
        query.categoryId1 = children.industryCode
        query.index1 = index
      }
      if (window.__sendIframeLinkMessage({ type: '2-1', query })) return
      this.$router.push({
        path: '/zxk/search/clueList',
        query: query
      })
    },
    hideMe() {
      this.lucklyAnimateShow = false
    },
    async luckyWheelFn() {
      if (await this.searchCount(2)) {
        this.LuckyWheelShow = true
      }
    },
    async luckyWheelFn2() {
      if (await this.searchCount(1)) {
        await ad1({})
        this.lucklyAnimateShow = true
      }
    },
    async searchCount(type) {
      const { data } = await opportunityExists({ adType: type })
      if (!data) {
        this.$message.warning('您的抽奖次数已用完，本次活动获取的线索分多日进行推送，每日解锁10条，可以至“我的收藏-解锁列表“查看。')
        return false
      }
      return true
    },
    startCallBack() {
      this.showClose = false
      this.$refs.LuckyWheel.play()
      setTimeout(() => {
        const num = Math.random() * 2 >> 0
        this.$refs.LuckyWheel.stop(num ? 7 : 5)
      }, 1000)
    },
    endCallBack(prize) {
      this.showClose = true
      const self = this
      this.$alert(`已获得了${prize.fonts[0].text}商机礼包`, '恭喜您！', {
        confirmButtonText: '确定',
        callback: () => {
          self.LuckyWheelShow = false
        }
      })
      ad2({ type: prize.type })
    },
    rollRun() {
      const that = this
      that.rollTop -= 40
      that.$nextTick(() => {
        // that.$refs.rollul.style.transition = '1s all'
        // that.$refs.rollul.style.transform = `translateY( ${that.rollTop}px)`
      })
      that.rollTimmer = setTimeout(() => {
        this.reseatRoll()
      }, 2000)
    },
    reseatRoll() {
      clearTimeout(this.rollTimmer2)
      const that = this
      if (that.rollTop <= -40) {
        that.rollTop = 0
        that.$nextTick(() => {
          // that.$refs.rollul.style.transition = 'unset'
          // that.$refs.rollul.style.transform = `translateY( ${that.rollTop}px)`
          const first = that.rollList.splice(0, 1)
          that.rollList.push(first[0])
          that.rollTimmer2 = setTimeout(() => { that.rollRun() }, 1000)
        })
      }
    },
    rollEnter() {
      // clearTimeout(this.rollTimmer)
      // this.reseatRoll()
    },
    rollLeave() {
      // this.rollRun()
    },
    open(i) {
      this.boxList[i] = false
    },
    lookMore() {
      this.$router.push({ name: '企业资讯', params: { name: this.searchNewsName } })
      // this.$router.push({name:'newsDetails', query: { name: this.searchNewsName}})
    },
    getToday() {
      return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()
    },
    getDay(day) {
      const today = new Date()
      const targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetday_milliseconds)

      const tYear = today.getFullYear()
      let tMonth = today.getMonth()
      let tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)

      return '' + tYear + tMonth + tDate
    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length === 1) {
        m = '0' + month
      }
      return m
    },
    async recommendList() {
      this.waiting = true
      const res = await recommendList()
      let { data = [] } = res || {}
      data = data || []
      // 判断没有数据就接着调用
      if (!data.length) {
        this.recommendListTimer = setTimeout(() => {
          this.recommendList()
        }, 2000)
        return
      }
      // 有数据了展示
      this.recommendListTimer && clearTimeout(this.recommendListTimer)
      this.recommendListTimer = null
      this.companyCards = data.slice(0, 9)
      // 统一数据格式
      this.companyCards.forEach(e => {
        if (!e.hasOwnProperty('unlock')) {
          this.$set(e, 'unlock', false)
        }
        if (!e.hasOwnProperty('star')) {
          this.$set(e, 'star', false)
        }
      })
      this.waiting = false
    },
    async getNews(name = '珍岛信息技术（上海）股份有限公司') {
      this.searchNewsName = name
      this.loading = true
      const res = await getNews({
        pageNum: 1,
        pageSize: 6,
        startTime: this.getDay(-364 / 2),
        endTime: this.getDay(0),
        name
      })
      if (res.data) {
        this.news = res.data.items
      } else {
        this.news = []
      }
      this.loading = false
    },

    async showDrawer(companyName, recommendReason, tag) {
      this.contactList(companyName, recommendReason, 1)
      await this.$nextTick()
      if (!this.$refs.vNumber.drawer) {
        this.$refs.vNumber.drawerTaggle()
        this.companyStatus = { companyName, tag }
      }
    },
    async contactList(companyName, recommendReason) {
      console.log(companyName, recommendReason)
      const res = await contactList({ companyName, recommendReason })

      this.numberData = res.data.map(e => {
        let source = []
        let sourceHref = []
        if (e.source && e.sourceHref) {
          source = e.source.split(',')
          sourceHref = e.sourceHref.split(',')
        }
        return { ...e, source, sourceHref }
      })
    },
    // 批量收藏
    async batchStar(companyNames) {
      const res = await batchStar({ companyNames, type: 1 }) // 先传1
      this.$message.success('收藏成功')
    }

  }

}
</script>
<style lang='scss' scoped>
::v-deep {
  .el-loading-spinner .circular {
    height: 38px !important;
    width: 38px !important;
  }
}

.colore6a23c {
  background-color: #fdf6ec;
  color: #e6a23c;
  display: inline-block;
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 12px;
}
.cardWrap {
  height: 263px;
  padding: 24px;
  background: #ffffff;
  // box-shadow: 0px 0px 24px 0px rgba(38,38,38,0.1);
  box-shadow: 0px 0px 18px 0px rgba(38, 38, 38, 0.1);
  border-radius: 5px;
  border: 1px solid #ffffff;
  margin-top: 8px;
  float: left;
  // cursor: pointer;
  transition: all 0.3s, height 0s;
  &:hover {
    position: relative;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .text {
    text-align: left;
    dd {
      font-size: 12px;
      display: inline-block;
      > div {
        margin-bottom: 12px;
      }
      span:nth-child(2) {
        color: #333;
      }
      &:nth-child(1) {
        min-width: 140px;
        max-width: 340px;
      }
      &:nth-child(2) {
        width: 210px;
      }
      &:nth-child(3) {
        max-width: 355px;
      }
    }
    dt {
      display: inline-block;
      margin: 0 20px;
    }
    span {
      color: #999;
    }
  }
  .address {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #999;
    span:nth-child(2) {
      color: #333;
    }
  }
}
.div-scrollbar {
  height: calc(100%);
  // overflow: auto;
  position: relative;
  // .dw16top{
  //   width: 100%;
  //   height: 16px;
  // }
  // &::-webkit-scrollbar {
  //   width: 7px;
  // }
  // &::-webkit-scrollbar-track {
  //   background-color: transparent;
  //   border-radius: 5px;
  // }
  // &::-webkit-scrollbar-thumb {
  //   background-color: rgba(0, 0, 0, 0.2);
  //   border-radius: 5px;
  // }
}
.div-search {
  margin-top: 16px;
  .search-content {
    width: calc(50% - 10px);
    padding: 16px 0;
    height: 391px;
    background: #fff;
    // border: 1px solid #f6f6f6;
    box-shadow: 0px 0px 18px 0px rgba(38, 38, 38, 0.05);
    border-radius: 4px;
    display: inline-block;
    .span-tag {
      display: inline-block;
      padding: 6px 16px;
      margin-right: 20px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 20px;
      background: RGBA(219, 232, 253, 1);
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        background: #4f7afd;
        color: #fff;
      }
    }
    ul li {
      margin-bottom: 18px;
      line-height: 20px;
      display: flex;
      b {
        width: 54px;
        cursor: pointer;
        display: inline-block;
        margin-right: 20px;
        &:hover {
          color: #4f7afd;
        }
      }
      span {
        width: calc(100% - 80px);
        display: inline-block;
      }
      em {
        margin-right: 20px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 400;
        color: #666666;
        &:hover {
          color: #4f7afd;
        }
      }
    }
    .search-title {
      display: flex;
      align-items: center;
      position: relative;
      line-height: 20px;
      padding-bottom: 16px;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      &::before {
        content: " ";
        display: block;
        width: 4px;
        height: 14px;
        margin-right: 7px;
        background: #5088ff;
        border-radius: 2px;
      }

      // height: 45px;
      // padding-left: 16px;
      // background: #eaf0ff;
    }
  }
}

.main {
  // background: #f0f2f5;
  padding-bottom: 14px;
  position: relative;
  overflow-x: hidden;
}
.content {
  // border: 15px solid #F0F2F5;
  // border-top: 0;
  // width: calc(100% - 30px);
  margin: 0 auto;
  // background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  .contentLeft {
    // width: calc(100% - 250px);
    margin: 0 auto;
    .banner {
      width: 100%;
      // height: 194px;
      cursor: pointer;
      .cover {
        width: 100%;
        // height: 102px;
        background-size: cover;
        background-position: center;
        // background-image: url("~@/assets/newicons/ic01.png");
        // background-color: red;
      }
    }
    .leftList {
      // background-color: #fff;
      margin-top: 22px;
    }
    .title {
      width: 100%;
      line-height: 36px;
      border-bottom: 1px solid #f0f2f5;
      display: flex;
      position: relative;
      // justify-content: space-between;
      // padding: 0 30px;
      border-bottom: 1px solid #eeeeee;
      > h4 {
        width: 91px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        text-align: center;
        cursor: pointer;
      }
      .is-tabs {
        // color: #4f7afd;
        border-bottom: 2px solid #4f7afd;
      }
      div {
        color: rgba(80, 136, 255, 1);
        cursor: pointer;
        margin-right: 10px;
        vertical-align: middle;
        position: absolute;
        right: 0px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          animation: none;
          -webkit-animation: none;
          -ms-animation: none;
          -moz-animation: none;
          -webkit-animation: none;
          -o-animation: none;
        }
        &:hover {
          color: #0072ff;
        }
        &:hover img {
          animation: changeRotate 1s linear infinite;
          -webkit-animation: changeRotate 1s linear infinite;
          -ms-animation: changeRotate 1s linear infinite;
          -moz-animation: changeRotate 1s linear infinite;
          -webkit-animation: changeRotate 1s linear infinite;
          -o-animation: changeRotate 1s linear infinite;
        }
      }
    }
    .detail {
      display: grid;
      justify-content: space-between;
      grid-template-columns: repeat(auto-fill, 32%);
      // max-height: 880px;
      // overflow: auto;

      .nameWrap .name {
        // cursor: pointer;
        display: inline-block;
        position: relative;
        // top: 5px;
        max-width: 90%;
        font-size: 16px;
        font-weight: 400;
        color: #000;
      }
      /deep/ .details .text dd {
        &:nth-child(1) {
          min-width: 122px;
          // max-width: 150px;
        }
        &:nth-child(2) {
          width: 150px;
        }
        &:nth-child(3) {
          max-width: 220px;
        }
      }
      .new-item {
        width: 33.3333%;
        padding: 0 11px;
        float: left;
      }
    }
  }
  .contentRight {
    width: 300px;
    float: right;
    .roll {
      height: 300px;
      background-color: #fff;
      .ttext {
        padding: 0 20px;
        font-size: 12px;
        color: #ffa72e;
      }
      .rollUP {
        overflow: hidden;
        font-size: 12px;
        height: 230px;
        ul {
          li {
            height: 40px;
            line-height: 40px;
            padding: 0 20px;
            font-size: 12px;
          }
        }
      }
    }
    .rightPaper {
      height: 826px;
      margin-top: 10px;
      background-color: #fff;
      overflow: hidden;
    }

    .title {
      line-height: 50px;
      border-bottom: 1px solid #f0f2f5;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      > h4 {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      div {
        cursor: pointer;
        font-size: 12px;
        &:hover {
          color: #00adff;
        }
      }
    }
    .detail {
      position: relative;
      text-align: center;
      padding: 10px;
      overflow: hidden;
      min-height: 600px;
      .everyNews {
        text-align: left;
        padding: 5px;
        border-bottom: 1px solid #f0f2f5;
        .newsTitle {
          font-size: 14px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
          display: block;
          margin-bottom: 6px;
          font-weight: 600;
        }
        .text {
          font-size: 12px;
          height: 48px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .fromTime {
          color: #aaa;
          font-size: 12px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin: 5px 0;
          > a {
            margin-right: 10px;
          }
          > span {
            font-size: 12px;
          }
        }
        .about {
          font-size: 12px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          span {
            font-size: 12px;
            color: #507afb;
          }
        }
      }

      .emptyBox {
        width: 100%;
        position: absolute;
        top: 25%;
        left: 50%;
        transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        img {
          width: 64px;
        }
        p {
          color: #aaa;
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
  }
}
.boxes {
  display: flex;
  justify-content: space-between;
  > div {
    cursor: pointer;
    img {
      width: 100px;
    }
  }
}
.imgDialog /deep/ .el-dialog {
  .el-dialog__header {
    border: unset;
    border: none;
    .el-dialog__close {
      position: relative;
      top: -8px;
    }
  }
}
.luckDialog /deep/ .el-dialog {
  background-color: transparent;
  box-shadow: unset;
  box-shadow: none;
  .el-dialog__header {
    border: unset;
    border: none;
  }
  .el-dialog__headerbtn {
    background-color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
  canvas {
    cursor: pointer;
  }
}
@keyframes changeRotate {
  0% {
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    -webkit-transform: rotateZ(0deg);
    -o-transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
    -ms-transform: rotateZ(360deg);
    -moz-transform: rotateZ(360deg);
    -webkit-transform: rotateZ(360deg);
    -o-transform: rotateZ(360deg);
  }
}

// @media screen and (max-width: 1600px) {
//   .content {
//     .contentLeft {
//       width: calc(100% - 260px - 10px);
//     }
//     .contentRight {
//       width: 260px;
//     }
//   }
// }
// @media screen and (max-width: 1400px) {
//   .content {
//     .contentLeft {
//       width: calc(100% - 220px - 10px);
//       .cardWrap {
//         /deep/.details {
//           width: calc(100% - 220px);
//           dt {
//             margin: 0 5px;
//           }
//         }
//       }
//       .banner .bannerLeft {
//         .left {
//           position: relative;

//           height: 100%;
//           width: 50%;
//           text-align: center;
//           .p1 {
//             font-size: 38px;
//             margin-top: 35px;
//           }
//           .p2 {
//             font-size: 32px;
//           }
//           .newPeo {
//             position: absolute;
//             transform: rotateZ(-45deg);
//             top: 30px;
//             left: 0;
//             font-size: 18px;
//           }
//         }
//         .right {
//           width: 70%;
//           text-align: center;
//           .p1 {
//             font-size: 24px;
//             margin-top: 36px;
//           }
//           .p2 {
//             font-size: 16px;
//             font-weight: 600;
//             margin: 12px;
//           }
//           .get {
//             font-size: 20px;
//             line-height: 30px;
//             width: 149px;
//             display: inline-block;
//             border: 1px solid #fff;
//             background-color: rgba(255, 255, 255, 0.4);
//           }
//         }
//       }
//       .banner .bannerRight {
//         height: 100%;
//         display: flex;
//         background-image: url("~@/assets/bannerRight.png");
//         background-color: #fff;
//         background-repeat: no-repeat;
//         background-size: contain;
//         background-position: right 34px;
//         background-size: 58%;
//         color: #2e85fb;
//         .left {
//           position: relative;
//           height: 100%;
//           width: 60%;
//           text-align: center;
//           .p1 {
//             font-size: 34px;
//             margin-top: 36px;
//             font-weight: 600;
//           }
//           .p2 {
//             font-size: 20px;
//             margin: 10px;
//           }
//           .get {
//             font-size: 14px;
//             line-height: 32px;
//             width: 136px;
//             display: inline-block;
//             background-color: #2e85fb;
//             border-radius: 5px;
//             color: #fff;
//           }
//           .newPeo {
//             position: absolute;
//             transform: rotateZ(-45deg);
//             top: 30px;
//             left: 0;
//             font-size: 18px;
//           }
//         }
//       }
//     }
//     .contentRight {
//       width: 220px;
//       // .roll .rollUP {
//       //   height: 207px;
//       // }
//       .title,
//       .roll .ttext {
//         padding: 0 10px;
//       }
//       .roll .rollUP ul li {
//         padding: 0 10px;
//       }
//     }
//     .companyCard /deep/.rightBtn span {
//       margin: 0 3px;
//     }
//     // .companyCard /deep/.tRecommend {
//     //   margin-left: 30px;
//     //   max-width: 74%;
//     //   div {
//     //     font-size: 12px;
//     //   }
//     // }
//   }
// }

.sty001 {
  padding: 4px 9px;
  border-radius: 3px;
  font-size: 12px;
  background: rgba(80, 136, 255, 0.15);
}
.sty002 {
  font-size: 13px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
}
.sty003 {
  font-size: 13px;
  font-weight: 400;
  color: #5088ff !important;
  line-height: 18px;
}
.sty004 {
  display: flex;
  align-items: center;
}
</style>
